import { render, staticRenderFns } from "./DataPrivacyPage.vue?vue&type=template&id=e91b7af2&"
import script from "./DataPrivacyPage.vue?vue&type=script&lang=js&"
export * from "./DataPrivacyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports